import { render, staticRenderFns } from "./orders.vue?vue&type=template&id=27a1d4e6&"
import script from "./orders.ts?vue&type=script&lang=ts&"
export * from "./orders.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports